export { SubHeading } from './Component'